const SESSION_STORAGE = {
    DATA: {
        newsIntro: true,
    },
    KEY: "perfume_movie",
};
export default class Storage {
    constructor() {
        //セッションストレージがあるかどうか確認
        if (typeof Storage !== "undefined" && sessionStorage) {
            // セッションストレージを取得
            this.data = JSON.parse(sessionStorage.getItem(SESSION_STORAGE.KEY) || JSON.stringify(SESSION_STORAGE.DATA));
        } else {
            // セッションストレージが使えない場合はデフォルトデータを設定
            this.data = { ...SESSION_STORAGE.DATA };
        }
    }

    set(prop, val) {
        if (prop && typeof val != "undefined") {
            this.data[prop] = val;
        }

        if (typeof Storage !== "undefined" && sessionStorage) {
            // セッションストレージを保存
            sessionStorage.setItem(SESSION_STORAGE.KEY, JSON.stringify(this.data));
        }
    }
}
